export class NotValidAccessTokenException extends Error {
  constructor(message?: string) {
    const _defaultMessage = 'Not valid access token';

    super(message ?? _defaultMessage);
    this.name = 'NotValidAccessTokenExeptions';
  }
}
